import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PropsWithChildren } from 'react'
import { ThemeProvider } from 'styled-components'

import { AuthenticationProvider } from '@/contexts/AuthenticationContext.tsx'
import { GlobalStyle } from '@/styles/globalStyles.tsx'
import theme from '@/styles/theme'

const queryClient = new QueryClient()

export const Providers = ({ children }: PropsWithChildren) => {
  const isWidgetRoute = window.location.pathname.split('/')[1] === 'widgets'

  return (
    <QueryClientProvider client={queryClient}>
      <AuthenticationProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          {children}
          {/* navigator.webdriver: keep the devtools overlay out of e2e runs.
              Closed by default so it never covers interactive content; the
              toggle button sits bottom-left, clear of the (right-aligned)
              appointment list actions. */}
          {!isWidgetRoute && !navigator.webdriver && (
            <ReactQueryDevtools buttonPosition="bottom-left" />
          )}
        </ThemeProvider>
      </AuthenticationProvider>
    </QueryClientProvider>
  )
}
